import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";
import { CMAControllerPatchRequest } from "../../apis/comps/cma/generated";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export type PatchCmaParams = {
  cmaId: string;
  clientDisplayName?: string;
  title?: string;
  subjectProperty?: CMAControllerPatchRequest["patchCMARequestDto"]["subjectProperty"];
};

export const usePatchCma = (props?: Props) => {
  const { onSuccess, onSettled } = props || {};
  const api = getCMAApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: PatchCmaParams) => {
      const { cmaId, clientDisplayName, title, subjectProperty } = params;
      const response = await api.cMAControllerPatch({
        id: cmaId,
        patchCMARequestDto: {
          root: { clientDisplayName, title },
          subjectProperty,
        },
      });

      return response;
    },
    onError: async (error, { cmaId }) => {
      console.error(`Failed to update CMA with id ${cmaId}`, error);
    },
    onSettled: (_, __, { cmaId }) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
        });
      }, 2000);
      onSettled?.();
    },
    onSuccess: () => {
      onSuccess?.();
    },
    mutationKey: [CMA_SCOPE_KEY, "patch-cma"],
  });

  return mutation;
};
